import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 100%;
  flex: 0 0 auto;
  height: auto;
  min-height: min-content;
  max-height: none;
  overflow-x: hidden;
  overflow-y: visible;
  margin: 0;
  border-radius: 12px;
  background: transparent;
  box-sizing: border-box;
  
  /* Custom scrollbar vertical azul */
  &::-webkit-scrollbar {
    width: 10px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: var(--info);
    border-radius: 10px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: var(--info);
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
  padding: 20px;
  min-height: fit-content;
`;

export const Card = styled.div`
  background: linear-gradient(145deg, var(--surface-1), var(--surface-2));
  border-radius: 16px;
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  transition: all 0.3s ease;
  border: 1px solid var(--accent-soft);
  height: 250px;
  display: flex;
  flex-direction: column;
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-md);
  }
`;

export const CardHeader = styled.div`
  background-color: var(--info);
  color: var(--text-on-accent);
  padding: 16px;
  font-family: 'Poppins', sans-serif;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.5px;
  border-bottom: 2px solid var(--accent);
`;

export const CardBody = styled.div`
  padding: 15px;
  background-color: var(--surface-1);
  flex-grow: 1;
  overflow: hidden;
  
  p {
    margin: 0 0 10px 0;
    font-family: 'Helvetica Neue', sans-serif;
    color: var(--text-primary);
    font-size: 14px;
    display: flex;
    align-items: center;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    &::before {
      content: "•";
      color: var(--accent);
      font-weight: bold;
      display: inline-block;
      width: 1em;
      margin-right: 8px;
    }
  }
`;

export const CardFooter = styled.div`
  background-color: var(--accent-secondary);
  padding: 10px 16px;
  text-align: right;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: var(--text-on-accent);
  font-weight: 500;
  border-top: 1px solid var(--border-subtle);
`;
export const CardActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding: 0.75rem 1rem 1rem;
  background: var(--surface-1);
  border-top: 1px solid var(--border-subtle);

  button {
    flex: 1 1 auto;
    min-width: 100px;
    width: auto;
    height: auto;
    min-height: 36px;
    margin-right: 0;
    padding: 6px 12px;
  }
`;

export const CardActionButton = styled.button`
  border: 1px solid var(--border-subtle);
  background: var(--brand-lime);
  color: var(--text-on-lime);
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: var(--shadow-sm);
  padding: 6px 12px;
  text-align: center;

  &:hover {
    transform: translateY(-1px);
    border-color: var(--accent);
  }
`;
